import { useContext, useEffect } from "react";
import { Button, Dialog } from "@mui/material";
import {
  CONTENT_ADD_FOLLOWUP,
  CONTENT_EDIT_FOLLOWUP,
  CONTENT_FOLLOWUPLIST,
  setDialogIsTouched,
  setfetchError,
  setfetchIsLoading,
  setfetchSuccess,
  setFieldData,
  setSelectedFollowUp,
  setShouldFetchData,
  setShowBackToFollowUpListButton,
  showContent,
  toggleDialog,
} from "../CaseFollowUps/state/actions";
import HistoryListView from "./components/modalcontent/HistoryListView";
import CreateFollowUp from "./components/modalcontent/CreateFollowUp";
import { Close } from "@mui/icons-material";
import LoadingIndicator from "../../../../../../global/LoadingIndicator";
import EditFollowUp from "./components/modalcontent/EditFollowUp";
import { case_detail } from "../../../../../../api/endpoints/case";
import DataContext from "../../../../../../../context/DataContext";
import ApiRequestErrorHandler from "../../../../../../global/ApiRequestErrorHandler";
import { CONTENT_VIEW_FOLLOWUP } from "./components/modalcontent/HistoryListView/state/actions";
import ViewFollowUp from "./components/modalcontent/ViewFollowUp";
import { ButtonsConfig } from "../CaseFollowUps/components/utils/buttonsConfig";
import { STATUS_TYPES } from "../CaseFollowUps/components/types/statusTypes";
import Error from "./components/modalcontent/Error";
import STRINGS from "../CaseFollowUps/components/utils/strings";
import { ACTIONABLE_ITEM_TYPE_STRING } from "../types/actionTypes";
import PropTypes from "prop-types";
import { IndexedDBService } from "../../../../../../../services/indexed-db-service";
//import { useParams } from "react-router-dom";
import { useFollowUpHistoryStore } from "../../FollowUpHistory/hooks/useFollowUpHistory";
import { useFollowUpCallLogger } from "./hooks/useFollowUpCallLogger";
import { EventsDispatchContext } from "../../../../../../../context/EventsProvider";
import { setFollowUpIdForCallTracking } from "../../../../../../../../state/actions";
import axios from "../../../../../../api/axios";
import { useHistoryNavigate } from "../../../../../../../hooks/useHistoryNavigate";
import { useRevalidator } from "react-router-dom";
import { useDashboardRefreshStore } from "../../../../../../modules/FollowUps/modules/hooks/useDashboardRefreshStore";

const FollowUpModal = ({ actionType, state, dispatch }) => {
  const { accessToken } = useContext(DataContext);
  const actionItem = String(ACTIONABLE_ITEM_TYPE_STRING[actionType]).replaceAll(
    " ",
    ""
  );
  const indexedDBService = new IndexedDBService(actionItem, "details");
  const globalEventDispatch = useContext(EventsDispatchContext);
  const followUpHistoryStore = useFollowUpHistoryStore();
  const { followUpId, sessionId } = useFollowUpCallLogger();
  const { navigationHistoryService } = useHistoryNavigate();
  const { revalidate } = useRevalidator();
  const { triggerRefresh } = useDashboardRefreshStore();

  const onCallEnd = () => {
    setFollowUpIdForCallTracking(globalEventDispatch, null);
  };

  useEffect(() => {
    let active = true;
    const onCallActive = () => {
      axios
        .post(
          `/api/actionable_items/${followUpId}/associate_call/`,
          { external_call_id: sessionId },
          {
            headers: { Authorization: `Token ${accessToken}` },
          }
        )
        .then((res) => res)
        .catch((error) => {
          let errArr = ApiRequestErrorHandler(error.toString());
          setfetchError(dispatch, { showError: true, errorMessage: errArr });
        });
    };
    if (active & sessionId & followUpId) {
      onCallActive();
    }
    return () => {
      //when component unmounts make sure listener is removed
      active = false;
    };
  }, [followUpId, sessionId]);

  const handleClose = () => {
    toggleDialog(dispatch, false);
    setfetchError(dispatch, false);
    setShowBackToFollowUpListButton(dispatch, false);
    showContent(dispatch, null);
    onCallEnd();
    if (!state.showDialog) {
      setSelectedFollowUp(dispatch, null);
    }
    const widgetToggle = document.querySelector(".Adapter_toggle");
    const widgetContainer = document.querySelector(".Adapter_root");
    if (!widgetContainer.classList.contains("Adapter_minimized")) {
      widgetToggle.click();
    }
    triggerRefresh();
    revalidate();
  };
  const getCompletedFollowUpHistory = () => {
    //Checking in case on Calendar and possible store not existing
    if (followUpHistoryStore) {
      followUpHistoryStore.setShouldFetchData(true);
    }
  };

  const createFollowUpRecord = (newFollowUp, indexedDBKey) => {
    case_detail
      .createFollowUp(newFollowUp, accessToken)
      .then((res) => {
        indexedDBService.delete(indexedDBKey);
        setfetchIsLoading(dispatch, true);
        return res;
      })
      .then((res) => {
        /*This setTimeout compensates for the gap in time between posting and getting a response of the followup and the backend asynchronously auto-generating. 
        Need a fullstack change to address this.
       */
        setTimeout(() => {
          setShouldFetchData(dispatch, true);
        }, 500);
        return res;
      })
      .then((res) => {
        setfetchSuccess(dispatch, true);
        getCompletedFollowUpHistory();
        return res;
      })
      .then((res) => {
        handleClose();
        return res;
      })
      .catch((error) => {
        let errArr = ApiRequestErrorHandler(error.toString());
        setfetchError(dispatch, { showError: true, errorMessage: errArr });
        setDialogIsTouched(dispatch, false);
      });
  };

  const editFollowUpRecord = (followUpId, newFollowUp, indexedDBKey) => {
    case_detail
      .updateFollowUp(followUpId, newFollowUp, accessToken)
      .then((res) => {
        indexedDBService.delete(indexedDBKey);
        setfetchIsLoading(dispatch, true);
        /*This setTimeout compensates for the gap in time between posting and getting a response of the followup and the backend asynchronously auto-generating. 
       Need a fullstack change to address this.
       */
        setTimeout(() => {
          setShouldFetchData(dispatch, true);
        }, 500);

        return res;
      })
      .then((res) => {
        setfetchSuccess(dispatch, true);
        getCompletedFollowUpHistory();
        return res;
      })
      .then((res) => {
        handleClose();
        return res;
      })
      .catch((error) => {
        let errArr = ApiRequestErrorHandler(error.toString());
        setfetchError(dispatch, { showError: true, errorMessage: errArr });
        setDialogIsTouched(dispatch, false);
      });
  };

  const markCompleteFollowUpRecord = (followUpId, formData, indexedDBKey) => {
    editFollowUpRecord(
      followUpId,
      {
        ...formData,
        status: STATUS_TYPES.DONE,
      },
      indexedDBKey
    );
    setFieldData(dispatch, {
      fieldName: actionType,
      data: null,
    });
  };

  const handleSubmitForm = (submitType, formData, indexedDBKey) => {
    if (submitType === ButtonsConfig.SubmitButtons.create.submitType) {
      createFollowUpRecord(formData, indexedDBKey);
    } else if (submitType === ButtonsConfig.SubmitButtons.update.submitType) {
      editFollowUpRecord(state.selectedFollowUp.id, formData, indexedDBKey);
    } else if (
      submitType === ButtonsConfig.SubmitButtons.markComplete.submitType
    ) {
      markCompleteFollowUpRecord(
        state.selectedFollowUp.id,
        formData,
        indexedDBKey
      );
    } else {
      let errArr = ApiRequestErrorHandler("Error Submitting Form");
      setfetchError(dispatch, errArr);
    }
  };

  const setUpDialogContent = (content) => {
    return getDialogContentUI(content);
  };

  const listenForUserInteraction = (value) => {
    setDialogIsTouched(dispatch, value);
  };

  const navigateToDetail = (caseId) => {
    window.open(
      `/client-detail/${caseId}${navigationHistoryService.get(
        "client-detail"
      )}`,
      "_blank"
    );
  };

  const getDialogContentUI = (content) => {
    switch (content) {
      case CONTENT_ADD_FOLLOWUP: {
        return (
          <CreateFollowUp
            onClickSubmit={handleSubmitForm}
            title={ACTIONABLE_ITEM_TYPE_STRING[actionType]}
            caseInfo={state.caseInfo}
            actionType={actionType}
            formIsTouched={listenForUserInteraction}
            navigateToDetail={navigateToDetail}
          />
        );
      }
      case CONTENT_EDIT_FOLLOWUP: {
        return (
          <EditFollowUp
            onClickSubmit={handleSubmitForm}
            title={ACTIONABLE_ITEM_TYPE_STRING[actionType]}
            selectedFollowUp={state.selectedFollowUp}
            actionType={actionType}
            caseInfo={state.caseInfo}
            formIsTouched={listenForUserInteraction}
            navigateToDetail={navigateToDetail}
          />
        );
      }
      case CONTENT_FOLLOWUPLIST: {
        return <HistoryListView caseInfo={state.caseInfo} />;
      }
      case CONTENT_VIEW_FOLLOWUP: {
        return (
          <ViewFollowUp
            title={
              ACTIONABLE_ITEM_TYPE_STRING[state.selectedFollowUp.actionType]
            }
            selectedFollowUp={state.selectedFollowUp}
            actionType={actionType}
            caseInfo={state.caseInfo}
            navigateToDetail={navigateToDetail}
          />
        );
      }
      default: {
        return <LoadingIndicator isLoading={true} />;
      }
    }
  };
  return (
    <Dialog
      open={state.showDialog}
      fullWidth
      maxWidth="lg"
      sx={{
        backgroundColor: "rgba(0, 0, 0, 0)",
      }}
    >
      <div className="p-2 text-center outer">
        <div className="text-right">
          <Button onClick={(e) => handleClose(e)}>
            <Close />
          </Button>
        </div>
        <div className="text-left">
          {state.prevContent === CONTENT_FOLLOWUPLIST && (
            <Button onClick={() => showContent(dispatch, CONTENT_FOLLOWUPLIST)}>
              Go Back to {STRINGS.FOLLOW_UP_LIST_TITLE}
            </Button>
          )}
        </div>
        <div className="p-2 text-center">
          {state.dialogIsLoading ? (
            <LoadingIndicator isLoading={true} />
          ) : (
            <div
              className="p-2 text-center"
              data-testid="FollowUp-Dialog-Content"
            >
              {setUpDialogContent(state.showContent)}
            </div>
          )}
          {state.error && !state.dialogIsTouched && (
            <Error error={state.errorArray} />
          )}
        </div>
      </div>
    </Dialog>
  );
};

FollowUpModal.propTypes = {
  actionType: PropTypes.string,
  state: PropTypes.object,
  dispatch: PropTypes.func,
};

export default FollowUpModal;
